import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { DATA_EVENTS, INTERNAL_EVENTS, SDK_EVENTS } from "../../../constants/events.cnst";
import { getHTML } from "../../base/domManager";
import { ActiveOrPassive } from "../../../../../hooks/ActiveOrPassive";
import { ClassMapConstanst, IdMapConstant, ProjConstants, RenderResponseType, Tabs } from '../../../constants/projConsts';
import KoreGenerateuuidPipe from "../../../utils/koregenerateuuid";
import { AskCustomer, Automation, MybotAttachmentAskCustomer } from "../automation/automation";
import RandomuuidPipe from "../../../utils/randomuuid";
import { addScrollButtons } from "../../../utils/scrollUtils";
import { addInterruptDropdownItem, addInterruptDropdownItemCustom, customTabShowAllDialogsPopup, RenderCustomTabDialog } from "../atom/dialogPopups";
import { DialogSuggestion } from "../suggestions/dialog/dialog";


export function RenderCustomTabHeaderLeftSections(props: any) {
    return (
        <>
            <div className="left-title-info">
                <div className="text-dropdown-info">
                    <h1 className="m-0">{props?.hostInstance?.languagedata?.CUSTOM_TAB}</h1>
                    <div className={`interrupt-wrapper aa-custom-tab-interrupt-wrapper aa-hidden`}>
                        <span className="dialogs-number aa-custom-tab-interrupt-length">2</span>
                        <div className="aa-dropdown aa-custom-tab-interrupt-dropdown-wrapper">
                            <button type="button" className="aa-dropdown-toggle aa-custom-tab-interrupt-toggle" id="playbookDrp">
                                <svg className="arrow-icon aa-selected-checklist-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52876 5.52858C3.78911 5.26823 4.21122 5.26823 4.47157 5.52858L8.00016 9.05717L11.5288 5.52858C11.7891 5.26823 12.2112 5.26823 12.4716 5.52858C12.7319 5.78892 12.7319 6.21103 12.4716 6.47138L8.47157 10.4714C8.21122 10.7317 7.78911 10.7317 7.52876 10.4714L3.52876 6.47138C3.26841 6.21103 3.26841 5.78892 3.52876 5.52858Z" fill="#667085" />
                                </svg>
                            </button>
                            <div className="aa-dropdown-content playbook-dropdown-content aa-p-0 aa-custom-tab-interrupt-dropdown-content" aria-labelledby="playbookDrp">
                                <div className="heading-text-scripts">{props?.hostInstance?.languagedata?.INTERRUPT_DIALOG}</div>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="bottom-titles aa-custom-tab-header-dialog-wrapper aa-hidden">
                    <p className="text-truncate aa-text-xs aa-custom-tab-header-dialog-name"></p>
                    <div className="entity-name-cstm">
                        <span className="aa-desc-xs medium">{props?.hostInstance?.languagedata?.STEP}:</span>
                        <span className="aa-text-xs medium text-truncate aa-custom-tab-header-entity-name"></span>
                    </div>
                </div>
            </div>
        </>
    )
}


export function RenderCustomTabHeaderRightSection(props: any) {
    return (
            <div className="actions-assist-header">
                <button className="solid-action aa-custom-tab-listview-btn" aria-label="button" title={props?.hostInstance?.languagedata?.LIST_VIEW}>
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M8.31583 6.00268C8.31583 5.78877 8.14241 5.61536 7.9285 5.61536H4.40105L4.3658 5.61694C4.1684 5.63475 4.01372 5.80065 4.01372 6.00268C4.01372 6.2166 4.18714 6.39001 4.40105 6.39001H7.9285L7.96375 6.38843C8.16115 6.37062 8.31583 6.20471 8.31583 6.00268Z" fill="#101828" />
                        <path d="M8.31583 7.76641C8.31583 7.55249 8.14241 7.37908 7.9285 7.37908H4.40105L4.3658 7.38066C4.1684 7.39847 4.01372 7.56437 4.01372 7.76641C4.01372 7.98032 4.18714 8.15373 4.40105 8.15373H7.9285L7.96375 8.15215C8.16115 8.13434 8.31583 7.96844 8.31583 7.76641Z" fill="#101828" />
                        <path d="M7.14001 4.23896C7.14001 4.02504 6.9666 3.85163 6.75268 3.85163H4.40105L4.3658 3.85321C4.1684 3.87102 4.01372 4.03693 4.01372 4.23896C4.01372 4.45287 4.18714 4.62629 4.40105 4.62629H6.75268L6.78794 4.6247C6.98533 4.60689 7.14001 4.44099 7.14001 4.23896Z" fill="#101828" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.22524 1.5H9.10431C9.64284 1.5 10.0795 1.93612 10.0795 2.47485V9.52515C10.0795 10.0639 9.64284 10.5 9.10431 10.5H3.22524C2.68671 10.5 2.25 10.0639 2.25 9.52515V2.47485C2.25 1.93612 2.68671 1.5 3.22524 1.5ZM9.10431 2.27466H3.22524C3.11431 2.27466 3.02466 2.36419 3.02466 2.47485V9.52515C3.02466 9.63581 3.11431 9.72534 3.22524 9.72534H9.10431C9.21524 9.72534 9.30489 9.63581 9.30489 9.52515V2.47485C9.30489 2.36419 9.21524 2.27466 9.10431 2.27466Z" fill="#101828" />
                    </svg>
                </button>
                <button className="solid-action aa-custom-tab-restart-btn aa-hidden" aria-label="button">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M6.56883 0.838644C6.41593 0.712508 6.1893 0.720994 6.04633 0.864052L6.02111 0.891816C5.89497 1.04471 5.90346 1.27134 6.04651 1.41431L6.77241 2.13974C4.27202 2.15882 2.25 4.19131 2.25 6.6948C2.25 9.21013 4.2912 11.25 6.80791 11.25C9.32463 11.25 11.3658 9.21013 11.3658 6.6948C11.3658 6.47992 11.1916 6.30571 10.9767 6.30571C10.7618 6.30571 10.5876 6.47992 10.5876 6.6948C10.5876 8.78024 8.89497 10.4718 6.80791 10.4718C4.72086 10.4718 3.02818 8.78024 3.02818 6.6948C3.02818 4.62198 4.70045 2.93826 6.77009 2.91797L6.04651 3.64128L6.02127 3.66902C5.89503 3.82183 5.90337 4.04848 6.04633 4.19153C6.19823 4.34353 6.44459 4.34361 6.59659 4.19171L7.9862 2.80301L8.01146 2.77525C8.13774 2.62237 8.12932 2.3956 7.9862 2.25257L6.59659 0.863872L6.56883 0.838644Z" fill="#101828" />
                    </svg>
                </button>

                <button className="solid-action stop-assist aa-custom-tab-terminate-btn" aria-label="button" title={props?.hostInstance?.languagedata?.TERMINATE}>
                    <span></span>
                </button>
            </div>
    )
}


const RenderEmptyCustomTabScreen = (props: any) => {
    const languageData = props?.hostInstance?.languagedata;
    return (
        <div className="empty-listing-triggers aa-custom-tab-empty">
            <h1 className="aa-text-sm medium">{languageData?.CUSTOM_TAB_DESC}</h1>
            <p className="aa-desc-xs center">{languageData?.CUSTOM_EMPTY_MSG}</p>
        </div>
    )
}


export function CustomTab({hostInstance}:any) {

    const [customArrayData, setCustomArrayData] = useState<any[]>([]);
    const [interruptDialog, setInterruptDialog] = useState({});
    const [interruptRun, setInterruptRun] = useState(false);

    const rootServiceInstance = hostInstance?.rootService;
    let currentEntityNode : any = null;
    let templateClick = false;
    let workflowDialogsData:any = [];

    useEffect(() => {
        initializeUI();
        listenCustomTabEvents();

        return () => {
            unregisterCustomTabEvents();
        }
    }, []);


    useEffect(() => {

        rootServiceInstance.handleCustomTabScroll(hostInstance);
        if(customArrayData?.length > 0){
            hideEmptyScreen();
        }
    }, [customArrayData]);

    useEffect(() => {
        handleDialogInterrupt(interruptDialog);
    }, [interruptDialog]);

    const initializeUI = () => {
        addEmptyScreen();
        addCustomTabHeader();
        addCustomTabScrollButtons();
    }


    const addCustomTabFooter = () => {

        const customTabFooterSectionRight = hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_DATA_WRAPPER_CONTAINER)?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION_RIGHT);
        customTabFooterSectionRight.innerHTML = '';
        
        workflowDialogsData.forEach((item:any,index:number) => {
            if(index >= 5){
                return;
            }
            const customTabFooterItem = getHTML(addInterruptDropdownItemCustom, {hostInstance, dialog: item}, hostInstance);
            hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, customTabFooterItem, {
                event: SDK_EVENTS.CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE,
                data: item
            });
            const customTabFooterSectionRight = hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_DATA_WRAPPER_CONTAINER)?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION)?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION_RIGHT);
            customTabFooterSectionRight?.append(customTabFooterItem);
            customTabFooterSectionRight?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_INTERRUPT_DIALOG_ITEM}${item?.positionId}`)?.addEventListener('click', (e:any) => {
                item.customTabInterrupt = true;
                hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, item);
                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
            });
        });
        hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_DATA_WRAPPER_CONTAINER)?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION)?.querySelector(ClassMapConstanst.CUSTOM_TAB_SHOW_ALL_DIALOGS)?.addEventListener('click', (e:any) => {
            hostInstance?.emit(INTERNAL_EVENTS.SHOW_ALL_DIALOGS, workflowDialogsData);
        });
    }

    const listenCustomTabEvents = () => {
        hostInstance.on(DATA_EVENTS.AGENT_ASSIST_CUSTOM_RESPONSE, handleCustomAssistResponse);
        hostInstance.on(INTERNAL_EVENTS.TEMPLATE_CLICK, handleTemplateClickEvents);
        hostInstance.on(DATA_EVENTS.END_OF_TASK_RESPONSE, handleEndOfTaskResponse);
        hostInstance.on(INTERNAL_EVENTS.CUSTOM_TAB_HISTORY, fetchCustomTabHistory);
        hostInstance.on(INTERNAL_EVENTS.CUSTOM_TAB_DIALOG_WORKFLOW, addWorkFlowDialogs);
        hostInstance.on(INTERNAL_EVENTS.SHOW_ALL_DIALOGS, renderShowAllDialogs);
        listenInterruptEvents();        
        listenRunClickEvents();
        listenTerminateEvents();
    }

    const unregisterCustomTabEvents = () => {
        hostInstance.off(DATA_EVENTS.AGENT_ASSIST_CUSTOM_RESPONSE, handleCustomAssistResponse)
        hostInstance.off(INTERNAL_EVENTS.TEMPLATE_CLICK, handleTemplateClickEvents);
        hostInstance.off(DATA_EVENTS.END_OF_TASK_RESPONSE, handleEndOfTaskResponse);
        hostInstance.off(INTERNAL_EVENTS.CUSTOM_TAB_HISTORY, fetchCustomTabHistory);
        hostInstance.off(INTERNAL_EVENTS.CUSTOM_TAB_DIALOG_WORKFLOW, addWorkFlowDialogs);
        hostInstance.off(INTERNAL_EVENTS.SHOW_ALL_DIALOGS, renderShowAllDialogs);
    }

    const addEmptyScreen = () => {
        const emptyScreen = getHTML(RenderEmptyCustomTabScreen,{},hostInstance);
        hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, emptyScreen, {
            event: SDK_EVENTS.CUSTOM_TAB_EMPTY_SECTION
        });
        hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_SECTION}`)?.append(emptyScreen);      
    }


    const addCustomTabHeader = () => {
        const CustomHeaderLeftSection = getHTML(RenderCustomTabHeaderLeftSections,{},hostInstance);
        const CustomHeaderRightSection = getHTML(RenderCustomTabHeaderRightSection,{},hostInstance);
        hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, CustomHeaderLeftSection, {
            event: SDK_EVENTS.CUSTOM_TAB_HEADER_LEFT_SECTION
        });
        hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, CustomHeaderRightSection, {
            event: SDK_EVENTS.CUSTOM_TAB_HEADER_RIGHT_SECTION
        });
        const headerSection = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_HEADER_SECTION}`);
        if(CustomHeaderLeftSection && CustomHeaderRightSection && headerSection){
            headerSection.append(CustomHeaderLeftSection);
            headerSection.append(CustomHeaderRightSection);
            handleHeaderClickEventsInCustomTab(CustomHeaderLeftSection, CustomHeaderRightSection);
        }
    }

    const handleHeaderClickEventsInCustomTab = (customLeftSectionHtml: any, customRightSectionHtml: any) => {
        hostInstance?.eventManager?.addEventListener?.(`${ClassMapConstanst.CUSTOM_TAB_TERMINATE_BTN}`, 'click', (e: any) => {
            hostInstance?.chatEle?.querySelector?.(`${ClassMapConstanst.TERMIANTE_POPUP}`).classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
            let terminateOverrideBtn =  hostInstance?.chatEle?.querySelector?.(`${ClassMapConstanst.TERMINATE_OVERRIDE_BTN}`);
            terminateOverrideBtn?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        }, customRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${ClassMapConstanst.CUSTOM_TAB_LISTVIEW_BTN}`, 'click', (e: any) => {
            hostInstance?.chatEle?.querySelector?.(`${ClassMapConstanst.LIST_VIEW_POPUP}`).classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
            formatListViewEntityList();
        }, customRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${ClassMapConstanst.CUSTOM_TAB_RESTART_BTN}`, 'click', (e: any) => {
        }, customRightSectionHtml);

        hostInstance?.eventManager?.addEventListener?.(`${ClassMapConstanst.CUSTOM_TAB_INTERRUPT_TOGGLE_BTN}`, 'click', (e: any) => {
            customLeftSectionHtml?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_INTERRUPT_DROPDOWN_WRAPPER}`)?.classList.toggle('show');
        }, customLeftSectionHtml);
    }

    const hideEmptyScreen = () => {
        const emptyScreen = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_EMPTY}`);
        if(emptyScreen){
            emptyScreen.classList.add(ClassMapConstanst.HIDE_ELEMENT);
        }
    }

    const formatListViewEntityList = () => {
        let entityList: any = [];
        let automation = getLastAutomation();
        if (automation.type === RenderResponseType.AUTOMATION) {
            let automationNodes = automation.automationNodes;
            automationNodes.forEach((node: any) => {
                if (node.nodeType === RenderResponseType.ENTITY_NODE) {
                    entityList.push(node);
                }
            });
            cloneExistingAutomationToListView(entityList);
        }
    }

    const getLastAutomation = () => {
        let lastAutomation: any;
        setCustomArrayData((prevResponse: any) => {
            lastAutomation = prevResponse[prevResponse?.length - 1];
            return prevResponse;
        });
        return lastAutomation
    };

    const cloneExistingAutomationToListView = (entityList: any) => {
        entityList.forEach((entity: any) => {
            let entityNode = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.ASK_CUST_NODE}${entity.uuid}`);
            let clonedNode = entityNode.cloneNode(true);
            clonedNode.querySelector(`${ClassMapConstanst.ENTITY_HEADER}`)?.remove();
            rootServiceInstance.handleEntityNodeClickEvents(clonedNode, entity, ProjConstants.CUSTOM, hostInstance);
            let listViewWrapper: any = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.LIST_VIEW_BODY}`);
            listViewWrapper?.append(clonedNode);
            if(clonedNode?.querySelector(`${ClassMapConstanst.ENTITY_EXPAND_BTN}`)){
                addEventListenersForListView(clonedNode);
            }
        });
    }

    const addEventListenersForListView = (entityNode: any) => {
        entityNode?.querySelector(`${ClassMapConstanst.ENTITY_EXPAND_BTN}`)?.addEventListener('click', (e: any) => {
            e.stopPropagation();
            const inputEle = entityNode?.querySelector(`${ClassMapConstanst.ENTITY_INPUT}`);
            const inputValue = inputEle?.dataset?.inputvalue;
            rootServiceInstance.showMoreTextInEntityNode(inputEle, hostInstance, inputEle?.scrollHeight, inputValue, true);
        },entityNode);
    }

    const renderShowAllDialogs = (dialogs:any) => {
        if(hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_SHOW_ALL_DIALOGS_POPUP)){
            hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_SHOW_ALL_DIALOGS_POPUP)?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
            hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION)?.classList?.add('opacity','1')
            return;
        }

        const showAllDialogsTemplate:any = getHTML(customTabShowAllDialogsPopup, {hostInstance, dialogs}, hostInstance);

        if(showAllDialogsTemplate){

            showAllDialogsTemplate?.querySelector(ClassMapConstanst.CUSTOM_TAB_POPUP_HEADER_CLOSE_BTN)?.addEventListener('click', (e:any) => {
                showAllDialogsTemplate.querySelector(`#${IdMapConstant.CUSTOM_TAB_SEARCH_INPUT}`).value = '';
                addCustomDialogsInPopup(dialogs);
                showAllDialogsTemplate?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
            });

            hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION)?.classList?.add('opacity','0.2')

            hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, showAllDialogsTemplate, {
                event: SDK_EVENTS.CUSTOM_TAB_SHOW_ALL_DIALOGS
            });

            hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_DATA_WRAPPER_CONTAINER)?.querySelector(ClassMapConstanst.CUSTOM_TAB_FOOTER_SECTION)?.append(showAllDialogsTemplate);
            showAllDialogsTemplate?.querySelector(`#${IdMapConstant.CUSTOM_TAB_SEARCH_INPUT}`)?.addEventListener('input', (e:any) => {
                searchCustomTabDialogs(e.target.value, dialogs);
            });
            addCustomDialogsInPopup(dialogs);
        }
    }

    const addCustomDialogsInPopup = (dialogs:any) => {
        const customDialogListContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_SHOW_ALL_DIALOGS_POPUP)?.querySelector(ClassMapConstanst.CUSTOM_TAB_DIALOG_LIST_CONTAINER);
        customDialogListContainer.innerHTML = '';
        dialogs.forEach((item:any) => {
            const customTabDialogItem:any = getHTML(RenderCustomTabDialog, {hostInstance: hostInstance, dialog: item}, hostInstance);
            customDialogListContainer?.append(customTabDialogItem);
            hostInstance?.emit(SDK_EVENTS.BEFORE_VIEW_INIT, customTabDialogItem, {
                event: SDK_EVENTS.CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE_IN_POPUP,
                data: item
            });
            customTabDialogItem?.addEventListener('click', (e:any) => {
                item.customTabInterrupt = true;
                hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, item);
                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
                hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_SHOW_ALL_DIALOGS_POPUP)?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
            })
        });
    }

    const addCustomTabScrollButtons = () => {
        addScrollButtons(
            hostInstance,
            ClassMapConstanst,
            rootServiceInstance,
            {
                containerClass: ClassMapConstanst.CUSTOM_TAB_SECTION,
                headerClass: ClassMapConstanst.CUSTOM_TAB_HEADER_SECTION,
                upArrowClass: ClassMapConstanst.CUSTOM_TAB_UP_ARROW,
                downArrowClass: ClassMapConstanst.CUSTOM_TAB_DOWN_ARROW,
                tabType: Tabs.CUSTOM_TAB
            }
        );
    }

    const addWorkFlowDialogs = (menuResponseArr:any) => {
        const customTabObj = rootServiceInstance.customTabPrefsObj;
        if(customTabObj?.customTabEnabled && customTabObj?.customTabPrefs?.isE){
            const workflowDialogs = customTabObj.customTabWlD;
            workflowDialogs.forEach((dialog:any) => {
                const filteredDialog = menuResponseArr.filter((item:any) => item.taskRefId === dialog);
                if(filteredDialog?.length > 0){
                    workflowDialogsData.push(filteredDialog[0]);
                }
            });
        }
        addCustomTabFooter();
    }

    const searchCustomTabDialogs = (searchValue:any, dialogs:any) => {
        const filteredDialogs = dialogs.filter((item:any) => item.intentName.toLowerCase().includes(searchValue.toLowerCase()));
        addCustomDialogsInPopup(filteredDialogs);
    }

    const handleCustomAssistResponse = (customResponse: any) => {
        if (customResponse && Object.keys(customResponse).length > 0) {
            if (!rootServiceInstance.isCustomTabAutomationOnGoing && customResponse?.cTEventStart) {
                rootServiceInstance.isCustomTabAutomationOnGoing = true;
                rootServiceInstance.updateCustomTabDialogTemplate(hostInstance, customResponse, true);
                addAutomationNodeInCustomTabResponse(customResponse);
            }
            updateAssistCustomResponse(customResponse); 
        }
        
    }

    const updateAssistCustomResponse = (data: any) => {
        rootServiceInstance.removeLoaderForAutomation(hostInstance, hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_SECTION}`) as HTMLElement);
        const responseType = rootServiceInstance.getCustomTabTypeOfResponse(data); 
        rootServiceInstance.handlePreviousAutomationNode(currentEntityNode, data, templateClick, hostInstance);
        formatResponseBasedOnType(data, responseType);
    }

    const formatResponseBasedOnType = (data: any, responseType: any) => {
        const responseId = KoreGenerateuuidPipe();

        let result: any = hostInstance.templateRenderService.getResponseUsingTemplate(data);
        data.templateResult = result;

        switch (responseType) {

            case RenderResponseType.AUTOMATION_NODE:
                handleAutomationNodeResponse(data, responseId);
                break;

            case RenderResponseType.SMALLTALK:
                handleSmallTalkResponse(data, responseId);
                break;
            default:
                break;
        }
    }

    const handleDialogInterrupt = (dialog: any) => {
        if (dialog && Object.keys(dialog).length > 0) {
            const footerTag = hostInstance.chatEle.querySelector(ClassMapConstanst.FOOTER);
            hostInstance.openCustomTab(footerTag, true);
            let currentDialogName = customArrayData[customArrayData?.length - 1]?.dialogName;
            rootServiceInstance.toggleInterruptPopup(hostInstance, true, currentDialogName);
        }
    }

    const handleAutomationNodeResponse = (data: any, responseId: string) => {
        if (data?.buttons?.[0]?.value) {
            let automationNodeObj = rootServiceInstance.prepareAutomationNodeResponse(data, responseId);
            automationNodeObj = data.isPrompt
                ? rootServiceInstance.prepareEntityNodeResponse(data, automationNodeObj, hostInstance)
                : rootServiceInstance.prepareMsgNodeResponse(data, automationNodeObj, hostInstance);
            currentEntityNode = data.isPrompt ? automationNodeObj : null;
            addNodeInAutomation(automationNodeObj);
        }
    }

    const addNodeInAutomation = (automationNodeObj: any) => {
        setCustomArrayData((prevResponse: any) => {
            const updatedArray = [...prevResponse];
            const lastObj = updatedArray[updatedArray.length - 1];
            if (lastObj?.type === RenderResponseType.AUTOMATION) {
                rootServiceInstance.handleErrorPrompts(lastObj, automationNodeObj, hostInstance);
                updateAutomationNode(lastObj, automationNodeObj);
                addNodeInListView(automationNodeObj, lastObj);
            }
            return updatedArray;
        });
    }

    const updateAutomationNode = (lastObj: any, automationNodeObj: any) => {
        automationNodeObj.dialogId = lastObj?.dialogId || '';
        lastObj.automationNodes.push(automationNodeObj);
        const entityDisplayName = automationNodeObj?.data?.entityDisplayName || automationNodeObj?.data?.entityName;
        if (entityDisplayName) {
            updateCustomTabHeaderEntityName(entityDisplayName);
        }
        rootServiceInstance.addDialogTemplate(automationNodeObj, lastObj, ProjConstants.CUSTOM, hostInstance);
    }

    const updateCustomTabHeaderEntityName = (entityDisplayName: string) => {
        const customTabHeaderEntityName = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_HEADER_ENTITY_NAME}`);
        customTabHeaderEntityName.innerText = entityDisplayName;
    }

    const addNodeInListView = (automationNode: any, automation: any) => {
        if (!hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.LIST_VIEW_POPUP}`)?.classList?.contains(ClassMapConstanst.HIDE_ELEMENT)) {
            renderEntityInListView(automationNode, automation);
        }
    }

    const renderEntityInListView = (entity:any,automation:any) => {
        if (entity?.type === RenderResponseType.AUTOMATION_NODE && entity?.nodeType === RenderResponseType.ENTITY_NODE) {
            let manualMode = true;
            let payload: any = { entityNode: entity, activeTab: ProjConstants.CUSTOM, manualMode, view: 'listView' }
            let template : any = '';
            if(entity.data.entityType != 'attachment'){
                template = getHTML(AskCustomer, payload, hostInstance);
            }else{
                entity.fileObj = {};
                template = getHTML(MybotAttachmentAskCustomer, payload, hostInstance);
            }   
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, template, {
                event: SDK_EVENTS.ASK_CUSTOMER_TEMPLATE,
                data: payload
            });
            rootServiceInstance.handleEntityNodeClickEvents(template, entity, ProjConstants.CUSTOM, hostInstance);
            let listViewWrapper: any = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.LIST_VIEW_BODY}`);
            listViewWrapper?.append(template);
            showLastNodeActionButtons(automation);
        }
    }

    const showLastNodeActionButtons = (lastAutomation:any) => {
        if (lastAutomation?.type === RenderResponseType.AUTOMATION || lastAutomation.type === RenderResponseType.SMALLTALK) {
            const lastObj = (lastAutomation?.type === RenderResponseType.AUTOMATION) ? lastAutomation?.automationNodes[lastAutomation.automationNodes?.length - 1] : lastAutomation;
            if (lastObj?.data?.isPrompt && lastObj.nodeType === RenderResponseType.ENTITY_NODE) {
                const askCustNode = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.ASK_CUST_NODE}${lastObj.uuid}`);
                const inputEle = askCustNode?.querySelector(`${ClassMapConstanst.ENTITY_INPUT}`);
                inputEle.readOnly = false;
                inputEle.placeholder = '';
            }
        }
    }


    const handleEndOfTaskResponse = (data: any) => {
        if(data && data?.crId === 'custom' && rootServiceInstance.isCustomTabAutomationOnGoing){
            rootServiceInstance.isCustomTabAutomationOnGoing = false;
            dialogTerminatedOrInterrupted(data);
            interruptDialogCheck();
        }
    }

    const dialogTerminatedOrInterrupted = (data: any, isHistory: boolean = false) => {
        const lastAutomation = getLastAutomation();
        rootServiceInstance.updateLocalStorageForCustomTab(hostInstance, lastAutomation, false);
        const dialogEndNode = rootServiceInstance.prepareDialogEndNodeResponse(lastAutomation.dialogId);
        const feedbackNode = rootServiceInstance.prepareFeedbackDataForDialog(lastAutomation, data, isHistory);
        rootServiceInstance.closeListView(hostInstance);
        showOrHideLastNodeActionButtons(false, true);
        addNodeInAutomation(dialogEndNode);
        addNodeInAutomation(feedbackNode);
    }

    const interruptDialogCheck = () => {
        setInterruptRun((flag) => {
            if (flag) {
                setInterruptDialog((dialog) => {
                    hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, dialog);
                    return dialog;
                });
                return false; // Reset interrupt run state
            }
            return flag;
        });
    }

    const showOrHideLastNodeActionButtons = (showInputIcons: boolean, disabled = false) => {
        const lastAutomation: any = getLastAutomation();
        if (lastAutomation?.type === RenderResponseType.AUTOMATION || lastAutomation.type === RenderResponseType.SMALLTALK) {
            const lastObj = lastAutomation?.type === RenderResponseType.AUTOMATION ? lastAutomation?.automationNodes[lastAutomation.automationNodes?.length - 1] : lastAutomation;

            if (lastObj?.data?.isPrompt && lastObj.nodeType === RenderResponseType.ENTITY_NODE) {
                const askCustNode = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.ASK_CUST_NODE}${lastObj.uuid}`);
                const inputEle = askCustNode?.querySelector(`${ClassMapConstanst.ENTITY_INPUT}`);
                if (!showInputIcons) {
                    if (disabled) {
                        inputEle.readOnly = true;
                        inputEle.placeholder = '';
                        inputEle.blur();
                    } else {
                        inputEle.readOnly = false;
                        inputEle.placeholder = '';
                        inputEle.focus();
                    }
                    rootServiceInstance.handleEntityInput(lastObj, hostInstance, true);
                } else {
                    showLastNodeActionButtons(lastAutomation);
                    rootServiceInstance.showEntityNodeInputButtons(askCustNode);
                }
                rootServiceInstance.toggleAttachmentDiv(askCustNode, inputEle, !showInputIcons);
                rootServiceInstance.addorRemoveAttachemntFileError(lastObj, hostInstance);
            }
        }
        
    }

    const listenRunClickEvents = () => {
        const handleRunClickEvent = (runEventObj: any) => {
            if (runEventObj && runEventObj.customTabInterrupt) {
                const footerTag = hostInstance.chatEle.querySelector(ClassMapConstanst.FOOTER);
                hostInstance.openCustomTab(footerTag, true);
                if (!rootServiceInstance.isCustomTabAutomationOnGoing) {
                    if (runEventObj.from === ProjConstants.INTERRUPT) {
                        removeDialogFromInterruptList(runEventObj);
                    }
                    runEventObj.positionId = RandomuuidPipe('positionId');
                    addAutomationNodeInCustomTabResponse(runEventObj);
                    rootServiceInstance.runDialogForAssistOrMybot(hostInstance, runEventObj);
                } else {
                    hostInstance.emit(INTERNAL_EVENTS.INTERRUPT_POPUP_EVENT, runEventObj);
                }
            }
        };

        
        hostInstance.on(INTERNAL_EVENTS.RUN_CLICK_EVENT, handleRunClickEvent);
    };

    const listenTerminateEvents = () => {
        const handleTerminateEvent = () => {
            const lastAutomation: any = getLastAutomation();
            if (rootServiceInstance.isCustomTabAutomationOnGoing) {
                rootServiceInstance.sendRunClickEvent(hostInstance, { intentName: ProjConstants.DISCARD_ALL, sourceMsgId: lastAutomation.sourceMsgId, positionId: lastAutomation.positionId, customTabInterrupt: true });
            }
            rootServiceInstance.toggleTerminatePopup(hostInstance, false);
        };

        const handleTerminateOverrideEvent = () => {
            hostInstance.handleOverrideMode(true, null);
            rootServiceInstance.toggleTerminatePopup(hostInstance, false);
            showOrHideLastNodeActionButtons(false);
        };

        hostInstance.on(INTERNAL_EVENTS.TERMINATE_EVENT, (data: any) => {
            if (data?.activeTab === Tabs.CUSTOM_TAB) {
                handleTerminateEvent();
            }
        });

        hostInstance.on(INTERNAL_EVENTS.TERMINATE_OVERRIDE_EVENT, (data: any) => {
            if (data?.activeTab === Tabs.CUSTOM_TAB) {
                handleTerminateOverrideEvent();
            }
        });

    };

    const removeDialogFromInterruptList = (runEventObj: any) => {
        const interruptDropdownContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_INTERRUPT_DROPDOWN_CONTENT);
        const interruptDialogItem = interruptDropdownContainer?.querySelector(`${ClassMapConstanst.CUSTOM_TAB_INTERRUPT_DIALOG_ITEM}${runEventObj.positionId}`);

        if (interruptDialogItem) {
            interruptDialogItem.remove();
        }
        rootServiceInstance.customInterruptDialogList.splice(runEventObj.index, 1);
        rootServiceInstance.toggleCustomTabInterruptDropdown(Tabs.CUSTOM_TAB, hostInstance);
    }

    const addAutomationNodeInCustomTabResponse = (runEventObj: any) => {
        const responseId = KoreGenerateuuidPipe();
        const automationRenderResponse = rootServiceInstance.prepareAutomationReponse(runEventObj, responseId, ProjConstants.CUSTOM);
        setCustomArrayData((prevResponse: any) => [...prevResponse, automationRenderResponse]);
        addAutomationTemplate(automationRenderResponse);
    }

    const addAutomationTemplate = (automation: any) => {
        const automationHtml: any = getHTML(Automation, { dialog: automation, hostInstance }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, automationHtml, { event: SDK_EVENTS.CUSTOM_TAB_DIALOG_WRAPPER, data: automation });

        appendToCustomTabSection(automationHtml);
        rootServiceInstance.addDialogTemplate(automation.automationNodes[0], automation, ProjConstants.CUSTOM, hostInstance);
    };


    const appendToCustomTabSection = (html: HTMLElement) => {
        const customTabSection = hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_SECTION);
        if (customTabSection) {
            const clonedHtml = html.cloneNode(true) as HTMLElement; // Clone the HTML element
            customTabSection.append(clonedHtml); // Append the cloned element
        }
    };
    

    const handleTemplateClickEvents = (obj: any) => {
        if (obj.tab === Tabs.CUSTOM_TAB) {
            let message = obj.messageText;
            let lastAutomation = getLastAutomation();
            templateClick = true;
            rootServiceInstance.handleTemplateClickEvents(message, Tabs.CUSTOM_TAB, lastAutomation.dialogId, hostInstance);
        }
    }

    const listenInterruptEvents = () => {
        const openInterruptPopup = (runEventObj: any) => {
            if (runEventObj.customTabInterrupt) {
                setInterruptDialog({ ...runEventObj });
            }
        };

        const handleInterruptRun = (data: any) => {
            if (data?.activeTab === Tabs.CUSTOM_TAB) {
                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
                const lastAutomation: any = getLastAutomation();

                if (rootServiceInstance.isCustomTabAutomationOnGoing) {
                    setInterruptRun(true);
                    rootServiceInstance.sendRunClickEvent(hostInstance, { intentName: ProjConstants.DISCARD_ALL, sourceMsgId: lastAutomation.sourceMsgId, positionId: lastAutomation.positionId, customTabInterrupt: true });
                }
            }
        };

        const handleInterruptRunLater = (data: any) => {
            if (data?.activeTab === Tabs.CUSTOM_TAB) {
                let interruptedDialog: any = {};
                setInterruptDialog((dialog: any) => {
                    dialog.from = ProjConstants.INTERRUPT;
                    interruptedDialog = dialog;
                    return dialog;
                });

                const interruptDropdownContainer = hostInstance?.chatEle?.querySelector(ClassMapConstanst.CUSTOM_TAB_INTERRUPT_DROPDOWN_CONTENT);

                if (!isDialogInInterruptList(interruptedDialog)) {
                    rootServiceInstance.customInterruptDialogList.push(interruptedDialog);
                    showInterruptDropdown(interruptDropdownContainer, interruptedDialog);
                    addRunClickEventListener(interruptedDialog, interruptDropdownContainer);
                }

                rootServiceInstance.toggleInterruptPopup(hostInstance, false);
            }
        };
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_POPUP_EVENT, openInterruptPopup);
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_ACCEPT_EVENT, handleInterruptRun);
        hostInstance.on(INTERNAL_EVENTS.INTERRUPT_RUNLATER_EVENT, handleInterruptRunLater);
    }

    const isDialogInInterruptList = (dialog: any) => {
        return rootServiceInstance.customInterruptDialogList.findIndex((d: any) => d.intentName === dialog.intentName) !== -1;
    }

    const showInterruptDropdown = (interruptDropdownContainer: any, interruptedDialog: any) => {
        const interruptDropdownItem = getHTML(addInterruptDropdownItem, { hostInstance, dialog: interruptedDialog }, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, interruptDropdownItem, {
            event: SDK_EVENTS.CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE,
            data: interruptedDialog
        });
        interruptDropdownContainer.append(interruptDropdownItem);
        rootServiceInstance.toggleCustomTabInterruptDropdown(Tabs.CUSTOM_TAB, hostInstance);
    }

    const addRunClickEventListener = (interruptedDialog: any, container: any) => {

        hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.CUSTOM_TAB_INTERRUPT_DIALOG_ITEM}${interruptedDialog?.positionId}`, 'click', () => {
            hostInstance.emit(INTERNAL_EVENTS.RUN_CLICK_EVENT, interruptedDialog);
            rootServiceInstance.toggleInterruptPopup(hostInstance, false);
        }, container);
    };

    const handleSmallTalkResponse = (data: any, responseId: string) => {
        if (data?.buttons?.[0]?.value) {
            let customDatObj = rootServiceInstance.prepareSmallTalkResponse(data, responseId);
            customDatObj = data.isPrompt
                ? rootServiceInstance.prepareEntityNodeResponse(data, customDatObj, hostInstance)
                : rootServiceInstance.prepareMsgNodeResponse(data, customDatObj, hostInstance);

            currentEntityNode = data.isPrompt ? customDatObj : null;
            rootServiceInstance.addSmallTalkTemplate(customDatObj, ProjConstants.CUSTOM, hostInstance);
            setCustomArrayData((prevResponse: any) => [...prevResponse, customDatObj]);
        }
    }

    const fetchCustomTabHistory = (historyData: any, customTabFeedbackData: any) => {
        if(historyData.length > 0){
            renderHistoryMessages(historyData, customTabFeedbackData);
        }
    }

    const renderHistoryMessages = (historyData: any, feedbackData: any) => {
        historyData.forEach((res: any)=>{
            if (res.type === "outgoing") {

                let formattedHistoryItem = rootServiceInstance.formatHistoryResponseToNormalRender(res, false);

                if (!rootServiceInstance?.isCustomTabAutomationOnGoing) {
                    if (formattedHistoryItem.intentName && formattedHistoryItem.positionId && formattedHistoryItem.buttons.length > 0) {
                        const dialog = rootServiceInstance.prepareDialogObjForCustomTabHistory(formattedHistoryItem);
                        rootServiceInstance.updateLocalStorageForCustomTab(hostInstance, dialog, true);
                        addAutomationNodeInCustomTabResponse(dialog);
                    }
                }

                if (rootServiceInstance?.isCustomTabAutomationOnGoing && formattedHistoryItem.eventType === "action" && formattedHistoryItem.endOfTask === true) {

                    let feedbackObj = feedbackData.find((feedback: any) => feedback.positionId === rootServiceInstance.currentCustomTabAutomationId);
                    dialogTerminatedOrInterrupted(feedbackObj, true);
                    currentEntityNode = null;
                }
                rootServiceInstance.handleHistoryPreviousAutomationNode(currentEntityNode, formattedHistoryItem, hostInstance);
                const responseType = rootServiceInstance.getCustomTabTypeOfResponse(formattedHistoryItem);                
                formatResponseBasedOnType(formattedHistoryItem, responseType);
                rootServiceInstance.handleCustomTabScroll(hostInstance);
            }
        })
    }


    return (
        <Fragment>
            <div className="custom-tab-data-wrapper-container aa-custom-tab-data-wrapper-container a-flex a-flex-column a-height-100 a-width-100 a-overflow-hidden">
                <div className="custom-tab-data-wrapper-container-content a-flex a-flex-column a-height-100 a-width-100 a-overflow-hidden">
                    <div className="assist-block-content cst-block-content a-overflow-hidden">
                        <div className="assist-header-content aa-custom-tab-header-section">
                        </div>
                        <div className="scroll-data-assist aa-custom-tab-section chat-widget-body-wrapper">
                            {/* all types of responses(suggestions, automation, smalltalk) */}
                        </div>
                    </div>
                    <div className="custom-tab-footer-section aa-custom-tab-footer-section a-flex-shrink-0 a-flex a-flex-column a-gap-8">
                        <div className="custom-dialog-workflows-header a-flex a-gap-8 a-align-items-center">
                            <h1 className="aa-desc-xs a-flex-shrink-0">{hostInstance?.languagedata?.DIALOG_WORKFLOWS}</h1>
                            <div className="line-divider"></div>
                            <button className="custom-tab-show-all-dialogs aa-custom-tab-show-all-dialogs show-dialog-task-btn aa-text-xs a-flex-shrink-0">{hostInstance?.languagedata?.SHOW_ALL_DIALOG}</button>
                        </div>
                        <div className="custom-tab-footer-section-right aa-custom-tab-footer-section-right a-flex a-gap-8 a-flex-wrap">
                            {/* all types of responses(suggestions, automation, smalltalk) */}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default CustomTab;
